import React, { Component } from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../../constants/routes';
import styled from 'styled-components';
// import DEFAULT_FLOOR from '../../assets/mics/defaultFloor.jpg';
import Loader from 'react-loader-spinner';
import ImageLoader from 'react-loading-image';
import { connect } from 'react-redux';
import { setCurrentProjectId, openDeleteProjectModal } from '../../store/actions/projectActions';
import logo from '../../assets/logo/app_icon_trans.png';
import moment from 'moment';
import * as MDICONS from '@material-ui/icons';
import ReactModal from 'react-modal';
import ProjectDeleteModal from '../project/addAndJoin/addProject/ProjectDeleteModal'
import { dateConverter } from '../../helper/Helper';


class ProjectBriefCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showVisibileModal: false,
        }
    }
    /// README: MODAL CONTROLLING
    handleOpenModal = (proid, coid) => {
        this.props.openDeleteProjectModal();
        this.setState({
            showVisibileModal: true,
            proid,
            coid,
        });
    }

    handleCloseModal = () => {
        this.setState({ showVisibileModal: false });
    }
    render() {
        const ViewDashboardButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: #fafafa;
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

        const { themeColors, alu, userData, modalStyles, project, companyData } = this.props;
        const { isProjectDeleted } = project;
        const { uid, employeeid } = userData;

        let subscriptionBoughtActive = false;
        if (userData.coid !== '-1') {
            let boughtOrderId = companyData ? 'boughtSubscription' in companyData ? companyData.boughtSubscription.orderId : null : null;
            subscriptionBoughtActive = boughtOrderId ? companyData.boughtSubscription.applied : false
        } else {
            subscriptionBoughtActive = true;
        }

        // console.log(props.projectCard)
        const { proid, projectTitle, email, companyName, accessMap, dateCreated, accessList, coid, profilePic } = this.props.projectCard;
        // console.log(accessList.length)
        /// getting ueid to pass into accessMap of project to get accessLevel
        var ueid = uid + employeeid;
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        // var parsedDate = new Date(dateCreated ? dateCreated.seconds + dateCreated.nanoseconds * 10 ** -9 : '');
        // var date = moment(parsedDate * 1000).format('dddd, MMMM Do, YYYY');
        var parsedDate=dateConverter(dateCreated?dateCreated.seconds*1000:'').parsedDate;
        return (
            <div className="container" key={proid} style={{ marginBottom: '20px', marginLeft: '0px', marginRight: '0px' }}>
                <div className="card h-100 " style={{ borderRadius: '20px' }}>


                    <div className="d-flex align-items-start" style={{ marginBottom: "10px", borderRadius: '25px', paddingLeft: '3px' }}>
                        <span className="badge badge-pill float-right px-3" style={{ backgroundColor: `${alu.color[accessLevel]}`, color: `${alu.textColor[accessLevel]}`, textAlign: "end", fontSize: "12px", fontStyle: "italic", borderRadius: '15px' }}>{alu.text[accessLevel]}</span>
                    </div>
                    <div style={{ padding: '20px' }}>
                        <div className="row">
                            <div className="col col-1 mr-3">
                                <img src={`https://avatars.dicebear.com/api/identicon/${proid}.svg?backgroundColor=%23ffffff`} alt="logo" style={{ scale: '1', width: '30px', height: '30px' }} />
                            </div>
                            <div className="col col-6 align-self-center">
                                <h5 className="" style={{ textAlign: "start", fontWeight: "bold", fontSize: '18px' }}>{projectTitle}</h5>
                                {/* <p style={{textAlign: "start",fontSize:'12px'}}>&nbsp;{date}</p> */}
                            </div>
                            <div className="col col-3">
                                <p className="align-middle"><MDICONS.Group style={{ width: '25px', height: '25px' }} />&nbsp;{accessList.length}</p>
                            </div>

                        </div>
                        <div className="ml-4 row">
                            <div className="col col-12 align-self-start" style={{ textAlign: "start", fontSize: '12px' }}><MDICONS.Schedule style={{ width: '16px', height: '16px' }} />&nbsp;{parsedDate}</div>
                            {/* <div className="col col-9 align-self-center" style={{ textAlign: "start", fontSize: '14px' }}>{date}</div> */}
                            {/* <div className="col col-"></div> */}
                        </div>
                    </div>

                    {/* BOTTOM OF CARD */}
                    {/* TODO: mt-auto make the footer align to bottom. *Donot Remove it* 
                https://stackoverflow.com/questions/51877488/bootstrap-4-card-footer-does-not-align-to-the-bottom-of-the-page
                */}
                    <div className="card-footer mt-auto" style={{ borderRadius: '13px' }}>
                        <div className="row">
                            <div className="col col-12">
                                <div className="d-flex">
                                    <div className="flex-fill">
                                        <ViewDashboardButton themeColors={themeColors}>
                                            {subscriptionBoughtActive ?
                                                <Link to={ROUTES.IND_PROJECT_DASHBOARD} className="btn btn-default btn-sm float-left" style={{ borderRadius: '10px' }} onClick={() => this.props.setCurrentProjectId(proid)}>Dashboard</Link>
                                                : <Link to={ROUTES.PRICING} className="btn btn-default btn-sm float-left" style={{ borderRadius: '10px' }} >Upgrade your plan</Link>}
                                        </ViewDashboardButton>
                                    </div>
                                    <div className="align-self-start pl-2">
                                        <ViewDashboardButton themeColors={themeColors}>

                                            <button className="btn btn-default btn-sm float-left" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(proid, coid) }} >Delete project</button>
                                        </ViewDashboardButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* PROJECT DELETEION MODAL  */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showVisibileModal && isProjectDeleted}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="Delete Project"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <ProjectDeleteModal proid={this.state.proid} coid={this.state.coid} />
                </ReactModal>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        userData: state.firebase.profile,
        modalStyles: state.appControl.modalStyles,
        project: state.project,
        companyData: state.firestore.data.Company,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentProjectId: (proid) => dispatch(setCurrentProjectId(proid)),
        openDeleteProjectModal: () => dispatch(openDeleteProjectModal()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectBriefCard);